import { render, staticRenderFns } from "./faceCollection.vue?vue&type=template&id=3a234425"
import script from "./faceCollection.vue?vue&type=script&lang=js"
export * from "./faceCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports